import { mapState, mapGetters, mapActions } from 'vuex'

export const deviceUserListComputed = {
  ...mapState('deviceUserList', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('deviceUserList', ['getDeviceUserList']),
}

export const deviceUserListMethods = mapActions('deviceUserList', [
  'fetchingDeviceUserList',
  'resetDeviceUserList',
  'deleteDeviceById',
])
